module.exports = __webpack_public_path__ + "images/monitor-attachment-higher-resolution.png";